//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { AbstractRoomContentModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({
   types: [AbstractRoomContentModel],
})
@Component({
    selector: 'room-content-presenter',
    template: '<room-content-item [id]="data().id" [roomContent]="data()" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomContentPresenterComponent {
    public data: WritableSignal<AbstractRoomContentModel> = signal<AbstractRoomContentModel>(null);
}